import React, { useState } from "react";
import CreateUser from "./CreateUser";
import ModifyUser from "./ModifyUser";
import DeleteUser from "./DeleteUser";

const UserManagement = () => {
  const [activeTab, setActiveTab] = useState("create");

  return (
    <div className="w-full px-6 py-4">
      
      {/* ✅ Tab Bar */}
      <div className="flex gap-6 border-b pb-3 mb-6">
        {["create", "modify", "delete"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-2 font-medium capitalize ${
              activeTab === tab
                ? "border-b-2 border-blue-500 text-blue-600"
                : "text-gray-500"
            }`}
          >
            {tab} User
          </button>
        ))}
      </div>

      {/* ✅ Tab Content */}
      {activeTab === "create" && <CreateUser />}
      {activeTab === "modify" && <ModifyUser />}
      {activeTab === "delete" && <DeleteUser />}
    </div>
  );
};

export default UserManagement;